import { useCallback, useState } from 'react';

export const useChangeEmployeeModal = () => {
  const [isChangeEmployeeModalOpen, setIsChangeEmployeeModalOpen] =
    useState(false);
  const openChangeEmployeeModal = useCallback(() => {
    setIsChangeEmployeeModalOpen(true);
  }, []);

  const closeChangeEmployeeModal = useCallback(() => {
    setIsChangeEmployeeModalOpen(false);
  }, []);

  return {
    isChangeEmployeeModalOpen,
    openChangeEmployeeModal,
    closeChangeEmployeeModal,
  };
};
